/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NetCloudWireIcon16Light } from './NetCloudWireIcon16Light';
import { NetCloudWireIcon16Regular } from './NetCloudWireIcon16Regular';
import { NetCloudWireIcon16Solid } from './NetCloudWireIcon16Solid';
import { NetCloudWireIcon20Light } from './NetCloudWireIcon20Light';
import { NetCloudWireIcon20Regular } from './NetCloudWireIcon20Regular';
import { NetCloudWireIcon20Solid } from './NetCloudWireIcon20Solid';
import { NetCloudWireIcon24Regular } from './NetCloudWireIcon24Regular';
import { NetCloudWireIcon24Solid } from './NetCloudWireIcon24Solid';
import { NetCloudWireIcon32Regular } from './NetCloudWireIcon32Regular';
import { NetCloudWireIcon64Regular } from './NetCloudWireIcon64Regular';
var sizes = {
    16: {
        light: NetCloudWireIcon16Light,
        regular: NetCloudWireIcon16Regular,
        solid: NetCloudWireIcon16Solid,
    },
    20: {
        light: NetCloudWireIcon20Light,
        regular: NetCloudWireIcon20Regular,
        solid: NetCloudWireIcon20Solid,
    },
    24: {
        regular: NetCloudWireIcon24Regular,
        solid: NetCloudWireIcon24Solid,
    },
    32: {
        regular: NetCloudWireIcon32Regular,
    },
    64: {
        regular: NetCloudWireIcon64Regular,
    },
};
export var NetCloudWireIcon = forwardRef('NetCloudWireIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
